export interface IPatientPhone {
	id: number;
	number: string;
	type: string;
	isPrimary: boolean;
	source: string;
	description?: string | null;
	createdAt?: string;
	updatedAt?: string;
}

export class PatientPhone implements IPatientPhone {
	id: number;
	number: string;
	type: string;
	isPrimary: boolean;
	source: string;
	description: string | null;
	createdAt: string;
	updatedAt: string;

	constructor(data: any) {
		this.id = data.id || 0;
		this.number = data.number || '';
		this.type = data.type || '';
		this.source = data.source || '';
		this.description = data.description || null;
		this.createdAt = data.created_at || data.createdAt || '';
		this.updatedAt = data.updated_at || data.updatedAt || '';

		// Set isPrimary from is_primary field OR check if source contains "primary" (case-insensitive)
		this.isPrimary =
			data.is_primary || data.isPrimary || (this.source && this.source.toLowerCase() === 'primary') || false;
	}

	get displayLabel(): string {
		return `${this.number}`;
	}

	parse() {
		return {
			id: this.id,
			number: this.number,
			type: this.type,
			isPrimary: this.isPrimary,
			source: this.source,
			description: this.description
		};
	}

	toOriginalFormat(): { [key: string]: any } {
		return {
			id: this.id,
			number: this.number,
			type: this.type,
			is_primary: this.isPrimary,
			source: this.source,
			description: this.description,
			created_at: this.createdAt,
			updated_at: this.updatedAt
		};
	}
}
